import { Box, OutlinedInput, OutlinedInputProps, SxProps } from '@mui/material';
import Typography from '@mui/material/Typography';
import { inputBox, inputOutlined } from 'app/components/CustomInput/CustomInput.sx';
import { ClipboardEventHandler, forwardRef, KeyboardEventHandler } from 'react';

interface Props {
  title?: string;
  placeholder?: string;
  value?: string;
  handleChange?: (e: any) => void;
  width?: string;
  disabled?: boolean;
  adornment?: any;
  isValid?: boolean;
  rest?: OutlinedInputProps['inputProps'];
  adornmentStart?: any;
  sx?: SxProps;
  handleFocus?: any;
  handleBlur?: any;
  errorText?: string;
  errorTextSx?: SxProps;
  onKeyDown?: KeyboardEventHandler;
  onPaste?: ClipboardEventHandler<HTMLDivElement>;
  helperText?: string;
  alwaysShowHelper?: boolean;
  mask?: string;
  multiline?: boolean;
  minRows?: number;
  maxRows?: number;
  readOnly?: boolean;
}

const Input = ({
  placeholder,
  value,
  disabled,
  readOnly = false,
  adornment,
  adornmentStart,
  handleChange,
  rest,
  isValid,
  handleFocus,
  handleBlur,
  onKeyDown,
  onPaste,
  multiline,
  minRows,
  maxRows,
}: Props) => {
  return (
    <OutlinedInput
      placeholder={placeholder}
      sx={{ ...inputOutlined(multiline) }}
      readOnly={readOnly}
      value={value}
      disabled={disabled}
      endAdornment={adornment}
      startAdornment={adornmentStart}
      onChange={handleChange}
      inputProps={{ ...rest }}
      error={isValid}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onKeyDown={onKeyDown}
      onPaste={onPaste}
      type={rest?.type}
      multiline={multiline}
      minRows={minRows}
      maxRows={maxRows}
    />
  );
};

const CustomInput = forwardRef((props: Props) => {
  const { title, width, isValid, errorText, errorTextSx, helperText, alwaysShowHelper } = props;

  return (
    <Box sx={width !== undefined ? { ...inputBox, width } : inputBox}>
      <Typography sx={{ fontSize: '15px', fontWeight: 400, lineHeight: 1 }}>{title}</Typography>
      <Input {...props} />
      {helperText && (!isValid || alwaysShowHelper) && (
        <Typography sx={{ fontSize: '13px', color: '#b8babc', marginTop: '4px' }}>
          {helperText}
        </Typography>
      )}
      {isValid && (
        <Typography sx={{ color: 'red', fontSize: '14px', ...errorTextSx }}>{errorText}</Typography>
      )}
    </Box>
  );
});

export default CustomInput;
